import { SET_IS_NEW_RECORD } from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default (value) => createProjectModalActions[SET_IS_NEW_RECORD](value);
